import { GET, POST, PUT, DELETE } from './api'

export const Create = async (params) => {
    return await POST(`/dashboards`, params, true);
}

export const Read = async (query = '') => {
    return await GET(`/dashboards${query}`, true);
}

export const ReadOne = async (id) => {
    return await GET(`/dashboards/${id}?populate=*`, true);
}

export const ReadByEmail = async (email) => {
    return await GET(`/dashboards?filters[email]=${email}`, true);
}

export const Update = async (params, id) => {
    return await PUT(`/dashboards/${id}`, params, true);
}

export const Delete = async (id) => {
    return await DELETE(`/dashboards/${id}`, true);
}

export const ReadEmployeeMonthCounts = async (companyId, year) => {
    return await GET(`/employee-summary?companyId=${companyId}&year=${year}`, true);
};

export const ReadHoleriteMonthCounts = async (year, companyId) => {
    return await GET(`/dashboard/count-sum-liquid-salary?year=${year}&company=${companyId}`, true);
}

export const ReadHoleriteMonthCountsForEmployee = async (year, companyId, type, month) => {
    const monthQueryParam = month ? `&month=${month}` : '';
    return await GET(`/dashboard/sum-liquid-salary-logged-user?year=${year}&companyId=${companyId}&type=${type}${monthQueryParam}`, true);
}

export const ReadTotalDescontosForEmployee = async (year, companyId, type, month) => {
    const monthQueryParam = month ? `&month=${month}` : '';
    return await GET(`/dashboard/sum-total-descontos-logged-user?year=${year}&companyId=${companyId}&type=${type}${monthQueryParam}`, true);
};

export const ReadTotalVencimentosForEmployee = async (year, companyId, type, month) => {
    const monthQueryParam = month ? `&month=${month}` : '';
    return await GET(`/dashboard/sum-total-vencimentos-logged-user?year=${year}&companyId=${companyId}&type=${type}${monthQueryParam}`, true);
};






